// import { get } from "lodash";

export default {
  selectDashboardUpdates: (state) => state.dashboardUpdates.dashboardUpdates,
  selectDashboardUpdatesArray: (state) => state.dashboardUpdates.dashboardUpdates.updates,
  selectDashboardUpdateId: (state) => state.dashboardUpdates.selectedDashboardUpdateId,
  selectDashboardUpdateModalId: (state) => state.dashboardUpdates.dashboardUpdateModalId,
};
